"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "palau": {
    "475f9adc": [{
      "hkey": "56a00765",
      "slug": "porto-raphael-punta-sardegna",
      "name": "Porto Raphael-Punta Sardegna",
      "primary": true,
      "skipSearch": false
    }],
    "punta-sardegna": [{
      "hkey": "56a00765",
      "slug": "porto-raphael-punta-sardegna",
      "name": "Porto Raphael-Punta Sardegna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;